import React from "react";
import { PAYMENT_OPTIONS, LABELS } from "./OrderSummaryConstants";
import { PaymentMethodsProps } from "./types";

const PaymentMethodRadio: React.FC<{
  method: string;
  selected: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({ method, selected, onChange }) => (
  <li>
    <label className="payment-method-label flex items-center gap-2 cursor-pointer">
      <input type="radio" name="paymentMethod" value={method} checked={selected === method} className="w-5 h-5" onChange={onChange} />
      <span>{method}</span>
    </label>
  </li>
);

interface ExtendedPaymentMethodsProps extends PaymentMethodsProps {
  isFullyPaid?: boolean;
  orderStatus?: string;
}

const PaymentMethods: React.FC<ExtendedPaymentMethodsProps> = ({ selected, onChange, remainingAmount, status, isFullyPaid, orderStatus }) => {
  // Don't show payment methods if order is cancelled
  if (orderStatus === "Cancelled") {
    return null;
  }

  // Don't show payment methods if order is fully paid
  if (isFullyPaid) {
    return (
      <div className="mb-4">
        <p className="text-lg font-semibold mb-2">{LABELS.PAYMENT_METHODS}</p>
        <div className="text-center py-4 bg-green-50 rounded border border-green-200">
          <p className="text-green-700 font-medium">No remaining balance - Order is ready for delivery</p>
        </div>
      </div>
    );
  }

  // Original logic for pending status with remaining amount
  if (status !== "Pending" || !remainingAmount || remainingAmount <= 0) return null;

  return (
    <div className="mb-4">
      <p className="text-lg font-semibold mb-2">{LABELS.PAYMENT_METHODS}</p>
      <ul className="flex justify-center gap-10 items-center">
        {PAYMENT_OPTIONS.map((method) => (
          <PaymentMethodRadio key={method} method={method} selected={selected} onChange={onChange} />
        ))}
      </ul>
    </div>
  );
};

export default PaymentMethods;
